//Componentes generales
import React, { useState, useMemo, useContext } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRSubcuentas";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos
import "./SubcuentaList.css";

/*
  Componente encargado de la vista de Subcuentas disponibles.
  Donde subcuentas es la lista de Subcuentas disponibles recuperados del context.
*/
function SubcuentaList({ subcuentas = [] }) {
  //state de filtro.
  const [filter, setFilter] = useState("");

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;


  const filteredSubcuentas = useMemo(() => {
    if (!filter) return subcuentas;

    return subcuentas.filter((s) => {
      if (!s) return false; // previene nulls
      const codDim = s.codDim?.toLowerCase() || "";
      const codDimDescrp = s.codDimDescrp?.toLowerCase() || "";
      const subCue = s.subCue?.toLowerCase() || "";
      const subCueDescrp = s.subCueDescrp?.toLowerCase() || "";

      return (
        codDim.includes(filter.toLowerCase()) ||
        codDimDescrp.includes(filter.toLowerCase()) ||
        subCue.includes(filter.toLowerCase()) ||
        subCueDescrp.includes(filter.toLowerCase())
      );
    });
  }, [subcuentas, filter]);

  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  return (
    <div>
      <div style={{ marginLeft: "-150px" }}>
        <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
      </div>

      <div className="container-subcuenta-list">
        <FixedSizeList
          height={height - 210}
          itemCount={filteredSubcuentas.length}
          itemSize={90}
          width={"100%"}
        >
          {({ index, style }) => (
            <RenderRow
              index={index}
              style={style}
              subcuentas={filteredSubcuentas}
            />
          )}
        </FixedSizeList>
      </div>
    </div>
  );
}

export default SubcuentaList;
